import { createContext } from "react";


export const IP_Context=createContext()



